import React from "react";
import Edit from "../assets/Edit.jsx";
import Eye from "../assets/Eye.jsx";
import Delete from "../assets/Delete.jsx";

const defaultRender = (value) => (value ?? "--");

const getEducationSectionsColumns = (onView, onEdit, onDelete) => [
  {
    title: "Title",
    dataIndex: "title",
    sorter: true,
    render: defaultRender,
  },
  {
    title: "Units",
    dataIndex: "units",
    sorter: true,
    render: defaultRender,
  },
  {
    title: "Display Order",
    dataIndex: "displayOrder",
    sorter: true,
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "isActive",
    sorter: true,
    render: (isActive) =>
      isActive ? (
        <span className="px-3 py-1 rounded-full uppercase text-xs text-center success_tag">
          Active
        </span>
      ) : (
        <span className="uppercase px-3 py-1 rounded-full text-xs text-center fail_tag">
          Inactive
        </span>
      ),
  },
  {
    title: "Actions",
    dataIndex: "id",
    render: (_, record) => (
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => onView(record)}>
          <Eye />
        </button>
        <button type="button" onClick={() => onEdit(record)}>
          <Edit />
        </button>
        <button type="button" onClick={() => onDelete(record)}>
          <Delete />
        </button>
      </div>
    ),
  },
];

export default getEducationSectionsColumns;
